<div class="pagination">
	<div class="first-column">
		<div class="buttons">
			<button
				class="chevron-button"
				[disabled]="currentPage === 1"
				(click)="onPageChange(currentPage - 1)"
			>
				<mat-icon
					class="chevron-left"
					[svgIcon]="'sanus-chevron-right'"
				></mat-icon>
			</button>

			<ng-container *ngFor="let page of pagesArray()">
				<button
					class="page-button"
					[class.active]="currentPage === page"
					(click)="onPageChange(page)"
				>
					{{ page }}
				</button>
			</ng-container>

			<div *ngIf="showEllipsis">...</div>

			<button
				class="chevron-button"
				[disabled]="currentPage === totalPages"
				(click)="onPageChange(currentPage + 1)"
			>
				<mat-icon [svgIcon]="'sanus-chevron-right'"></mat-icon>
			</button>
		</div>
	</div>
	<div class="second-column">
		<div class="info">N° de linhas: {{ limit }}</div>
		<div class="info">
			Exibindo {{ pageQuantityInitial }} a {{ pageQuantityFinal }} de
			{{ count }} registros
		</div>
	</div>
</div>
